var SCALABLE_PREFIXES = [
    'dice_',
    'deck_',
    'spinner_',
    'analog_',
    'timer_',
    'numberRacks_',
    'numberChart_',
    'linkingCube_',
    'fractionTiles_',
    'arrayModel_',
    'numberFrame_',
    'counter_',
    'numberFrameCounter_',
    'protractor_',
    'patternShapes_',
    'numberPiece_',
    'moneyPiece_',
    'numberLine_',
    'coloredTiles_',
    'linearPiece_',
    'coinsAndCounters_',
];
/**
 * Resolve the current scale for a selection of tools.
 * Returns the first tool's scale that can be resolved; falls back to 1.
 */
export function calcScale(selectedTool, manipulative, table) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _loop_1 = function (toolId) {
        if (SCALABLE_PREFIXES.some(function (p) { return toolId.startsWith(p); })) {
            var item = manipulative.find(function (m) { return m.data.id === toolId; });
            if (item)
                return { value: (_b = (_a = item.data) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1 };
            return "continue";
        }
        if (toolId.startsWith('card_')) {
            var deck = manipulative.find(function (m) { return m.data.type === 'deck' && m.data.cards.some(function (c) { return c.id === toolId; }); });
            if (deck && deck.data.type === 'deck') {
                var card = deck.data.cards.find(function (c) { return c.id === toolId; });
                return { value: (_d = (_c = card === null || card === void 0 ? void 0 : card.scale) !== null && _c !== void 0 ? _c : deck.data.scale) !== null && _d !== void 0 ? _d : 1 };
            }
            return "continue";
        }
        if (toolId.startsWith('manipulativeGroup_')) {
            var members = manipulative.filter(function (m) { return m.data.groupId === toolId; });
            if (members.length === 0)
                return "continue";
            var isNmpGroup = members.every(function (m) { return m.data.type === 'numberPiece' || m.data.type === 'moneyPiece'; });
            var isPatternShapesGroup = members.every(function (m) { return m.data.type === 'patternShapes'; });
            var isCCGroup = members.every(function (m) { return m.data.type === 'coinsAndCounters'; });
            // coloredTiles groups may also contain linearPiece members — treat the same as pure CT
            var isColoredTilesGroup = members.every(function (m) { return m.data.type === 'coloredTiles' || m.data.type === 'linearPiece'; }) &&
                members.some(function (m) { return m.data.type === 'coloredTiles'; });
            var isFractionTilesGroup = members.every(function (m) { return m.data.type === 'fractionTiles'; });
            if (isNmpGroup || isPatternShapesGroup || isCCGroup || isFractionTilesGroup) {
                return { value: (_f = (_e = members[0].data) === null || _e === void 0 ? void 0 : _e.scale) !== null && _f !== void 0 ? _f : 1 };
            }
            if (isColoredTilesGroup) {
                var firstTile = members.find(function (m) { return m.data.type === 'coloredTiles'; });
                return { value: (_h = (_g = firstTile === null || firstTile === void 0 ? void 0 : firstTile.data) === null || _g === void 0 ? void 0 : _g.scale) !== null && _h !== void 0 ? _h : 1 };
            }
            return { value: (_k = (_j = members[0].data) === null || _j === void 0 ? void 0 : _j.groupScale) !== null && _k !== void 0 ? _k : 1 };
        }
        if (toolId.startsWith('tableText_')) {
            var tableIndex = Number(toolId.split('_')[1]);
            var scale = (_m = (_l = table[tableIndex]) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.scale;
            if (scale !== undefined)
                return { value: scale };
            return "continue";
        }
    };
    for (var _i = 0, selectedTool_1 = selectedTool; _i < selectedTool_1.length; _i++) {
        var toolId = selectedTool_1[_i];
        var state_1 = _loop_1(toolId);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return 1;
}
